export default __webpack_public_path__ + "static/media/PAS3GROOVE1.03B.f77c6da4.mp3";